var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.886 248.629C133.509 236.544 265.041 170.958 265.041 216.946C265.041 255.2 199.95 300 145.172 300C89.8946 299.101 54.3969 282.134 22.528 255.129C21.2732 254.043 22.691 252.146 24.2517 252.748C47.3929 261.676 74.1391 255.721 96.886 248.629ZM50.091 80.0563C66.0812 59.6992 69.8272 92.6349 105.815 112.872C150.853 139.134 208.422 125.421 254.539 149.44C280.934 165.653 264.16 179.941 237.83 181.493C185.188 184.674 130.753 196.634 84.421 211.754C54.4676 220.873 24.2518 221.932 12.2733 210.264C-23.4058 174.913 27.8588 109.205 50.091 80.0563ZM181.279 0C246.601 0 300 109.673 300 175.068C300 186.11 289.821 186.11 289.82 175.595C289.82 134.165 248.121 100.864 171.952 100.864C138.13 100.864 100.368 80.0563 100.368 50.062C100.368 21.7328 124.536 9.85727e-06 181.279 0Z",
    fill: "url(#paint0_linear_2839_22305)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2839_22305",
    x1: 0,
    y1: 150,
    x2: 300,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSign);
export default __webpack_public_path__ + "static/media/LogoSign.46807e6bad14777e0d2936f4ff1b369f.svg";
export { ForwardRef as ReactComponent };